import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.0575 5.90625H4.72513C3.99006 5.90625 3.62225 5.90625 3.34149 6.0493C3.09453 6.17514 2.89389 6.37578 2.76805 6.62274C2.625 6.9035 2.625 7.27131 2.625 8.00638V11.6814C2.625 12.4164 2.625 12.7838 2.76805 13.0645C2.89389 13.3115 3.09453 13.5125 3.34149 13.6383C3.62198 13.7812 3.98936 13.7812 4.72299 13.7812H11.027C11.7607 13.7812 12.1275 13.7812 12.408 13.6383C12.6549 13.5125 12.8563 13.3115 12.9821 13.0645C13.125 12.7841 13.125 12.4172 13.125 11.6836V8.00422C13.125 7.27059 13.125 6.90323 12.9821 6.62274C12.8563 6.37578 12.6549 6.17514 12.408 6.0493C12.1272 5.90625 11.7602 5.90625 11.0251 5.90625H9.69211M6.0575 5.90625H9.69211M6.0575 5.90625C5.97386 5.90625 5.90625 5.83845 5.90625 5.75481V3.9375C5.90625 2.85019 6.78769 1.96875 7.875 1.96875C8.96231 1.96875 9.84375 2.85019 9.84375 3.9375V5.75481C9.84375 5.83845 9.77575 5.90625 9.69211 5.90625",
      stroke: "#94A3B8",
      "stroke-width": "1.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }